import { render, staticRenderFns } from "./CustomerReceiveRow.vue?vue&type=template&id=072a2a56&scoped=true"
import script from "./CustomerReceiveRow.vue?vue&type=script&lang=js"
export * from "./CustomerReceiveRow.vue?vue&type=script&lang=js"
import style0 from "./CustomerReceiveRow.vue?vue&type=style&index=0&id=072a2a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a2a56",
  null
  
)

export default component.exports